import React, { useState, useEffect } from 'react';
import { Button, FormControl, Input, InputLabel, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import FutureBalanceReportCalc from '../../shared/Reports/FutureBalanceReportCalc';
import FutureResults from './futureResults';

const StyledForm = styled('form')(({ theme }) => ({
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  marginRight: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
  width: '140px'
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginRight: theme.spacing(1),
  boxShadow: '0 4px 12px rgba(0, 98, 105, 0.3)',
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: '0 6px 16px rgba(0, 98, 105, 0.4)',
  },
  transition: 'all 0.3s ease',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  }
}));

const SubTitle = styled(Typography)(({ theme }) => ({
  padding: theme.spacing(3, 3, 2, 3),
  fontWeight: 700,
  color: '#1a1a1a',
}));

const updateFutureBalance = (event, item, updateItem) => {
  if (event)
    event.preventDefault();

  const result = FutureBalanceReportCalc.getReport(
    parseFloat(item.currentValue),
    parseFloat(item.averageDifference),
    parseFloat(item.monthlyIncreaseRate),
    parseInt(item.numberOfYears));
  updateItem({ ...item, futureBalance: result })
};

const FutureIncome = props => {
  const { monthlyIncreaseRate, currentValue, averageDifference, numberOfYears } = props;

  const [item, updateItem] = useState({
    monthlyIncreaseRate: parseFloat(monthlyIncreaseRate).toFixed(2),
    currentValue: parseFloat(currentValue).toFixed(2),
    averageDifference: parseFloat(averageDifference).toFixed(2),
    numberOfYears: parseInt(numberOfYears),
    futureBalance: FutureBalanceReportCalc.getReport(
      parseFloat(currentValue),
      parseFloat(averageDifference),
      parseFloat(monthlyIncreaseRate),
      parseInt(numberOfYears))
  });

  useEffect(() => {
    var tempItem = {
      monthlyIncreaseRate: parseFloat(monthlyIncreaseRate).toFixed(2),
      currentValue: parseFloat(currentValue).toFixed(2),
      averageDifference: parseFloat(averageDifference).toFixed(2),
      numberOfYears: parseInt(numberOfYears),
      futureBalance: FutureBalanceReportCalc.getReport(
        parseFloat(currentValue),
        parseFloat(averageDifference),
        parseFloat(monthlyIncreaseRate),
        parseInt(numberOfYears))
    };

    updateItem({ ...tempItem });
  }, [monthlyIncreaseRate, currentValue, averageDifference, numberOfYears]);

  return (
    <>
      <SubTitle component="h2" variant="h5">
        Saldo futuro
        </SubTitle>
      <StyledForm onSubmit={event => updateFutureBalance(event, item, updateItem)}>
        <StyledFormControl>
          <InputLabel htmlFor="currentValue">Saldo atual</InputLabel>
          <Input id="currentValue" name="currentValue" autoFocus type="number" step="0.01"
            value={item.currentValue}
            onChange={event => updateItem({ ...item, currentValue: event.target.value })} />
        </StyledFormControl>
        <StyledFormControl>
          <InputLabel htmlFor="averageDifference">Aporte mensal</InputLabel>
          <Input id="averageDifference" name="averageDifference" type="number" step="0.01"
            value={item.averageDifference}
            onChange={event => updateItem({ ...item, averageDifference: event.target.value })} />
        </StyledFormControl>
        <StyledFormControl>
          <InputLabel htmlFor="value">Rendimento/mes(%)</InputLabel>
          <Input id="monthlyIncreaseRate" name="monthlyIncreaseRate" type="number" step="0.01"
            value={item.monthlyIncreaseRate}
            onChange={event => updateItem({ ...item, monthlyIncreaseRate: event.target.value })} />
        </StyledFormControl>
        <StyledFormControl>
          <InputLabel htmlFor="numberOfYears">Período (anos)</InputLabel>
          <Input id="numberOfYears" name="numberOfYears" type="number" step="1"
            value={item.numberOfYears}
            onChange={event => updateItem({ ...item, numberOfYears: event.target.value })} />
        </StyledFormControl>
        <StyledButton
          type="submit"
          variant="contained"
          color="primary"
        >
          Calcular
          </StyledButton>
      </StyledForm>
      <FutureResults result={item.futureBalance}></FutureResults>
    </>
  );
};


export default FutureIncome;
